var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 63,
    viewBox: "0 0 67 63",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.845 22.8589L33.5822 2.72665L40.3194 22.8589C40.6579 23.8705 41.601 24.5558 42.6676 24.5654L63.8844 24.7566L46.8303 37.3929C45.9739 38.0276 45.614 39.1354 45.934 40.1522L52.3088 60.4055L35.0341 48.0814C34.1654 47.4616 32.999 47.4616 32.1302 48.0814L14.8555 60.4055L21.2303 40.1522C21.5503 39.1354 21.1905 38.0276 20.334 37.3929L3.27992 24.7566L24.4967 24.5654C25.5634 24.5558 26.5064 23.8705 26.845 22.8589Z",
    stroke: "#FFE682",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty_star.365ce00cc8748035a5aafb47bf5c469c.svg";
export { ForwardRef as ReactComponent };